import { translationResources } from "./resources.mjs";

export const DEFAULT_INTERFACE_LOCALE = "ru";

export function supportedInterfaceLocales() {
  return Object.keys(translationResources);
}

export function resolveInterfaceLocale(requested) {
  const normalized = String(requested || "").trim().toLowerCase().replaceAll("_", "-");
  const language = normalized.split("-", 1)[0];
  return Object.prototype.hasOwnProperty.call(translationResources, language)
    ? language
    : DEFAULT_INTERFACE_LOCALE;
}

export function resolveLocalePriority({ savedLocale, cachedLocale, browserLocale, authenticated }) {
  // An authenticated profile is authoritative. Browser language is only an
  // initial hint before a user has a saved preference.
  if (authenticated) {
    if (savedLocale) return resolveInterfaceLocale(savedLocale);
    if (cachedLocale) return resolveInterfaceLocale(cachedLocale);
    return DEFAULT_INTERFACE_LOCALE;
  }
  return resolveInterfaceLocale(cachedLocale || browserLocale);
}

export function translateInterface(locale, key) {
  const resolved = resolveInterfaceLocale(locale);
  const localized = translationResources[resolved]?.messages?.[key];
  if (typeof localized === "string" && localized.trim()) return localized;

  const fallback = translationResources[DEFAULT_INTERFACE_LOCALE]?.messages?.[key];
  if (typeof fallback === "string" && fallback.trim()) return fallback;

  // Unknown semantic keys stay visible and deterministic, never blank.
  return key;
}

export function localeNativeName(locale) {
  const resolved = resolveInterfaceLocale(locale);
  return translationResources[resolved]?.nativeName || resolved;
}
